import axios from 'axios';

import { setupInterceptors } from './interceptors';

// eslint-disable-next-line import/prefer-default-export
export const api = setupInterceptors(axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
}));
